import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportNSByAverageCarAgeItog = ({ row, items }) => {
  const renderItem = [
    row.ownershipPeriodFromOne,
    row.carsTotalOne,
    row.ownershipPeriodFromTwo,
    row.carsTotalTwo,
    row.ownershipPeriodToOne + row.ownershipPeriodToTwo,
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByAverageCarAgeItog;
